import withReducer from '../../store/withReducer'
import ReportsReport from './container'
import reducer from './module'

export default withReducer('reportsReport', reducer)(ReportsReport)



// WEBPACK FOOTER //
// ./src/legacy/pages/ReportsReport/index.js